/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentResponseWithRelations } from './assessmentResponseWithRelations';
import { QuestionWithRelations } from './questionWithRelations';


/**
 * (tsType: QuestionAnswerWithRelations, schemaOptions: { includeRelations: true })
 */
export interface QuestionAnswerWithRelations { 
    id?: string;
    answerText?: string;
    answerValue?: object;
    answeredOn: string;
    responseId: string;
    questionId: string;
    response?: AssessmentResponseWithRelations;
    question?: QuestionWithRelations;
}

